<template>
  <div class="novice">
    <img src="../assets/images/novice1.jpg" alt="">
    <img src="../assets/images/novice2.jpg" alt="">
    <img src="../assets/images/novice3.jpg" alt="">
    <img src="../assets/images/novice4.jpg" alt="">
    <img src="../assets/images/novice5.jpg" alt="">
    <img src="../assets/images/novice6.jpg" alt="">
    <img src="../assets/images/novice7.jpg" alt="">
    <img src="../assets/images/novice8.jpg" alt="">
    <img src="../assets/images/novice9.jpg" alt="">
  </div>
</template>

<script>
export default {
  name: 'novice',
  mounted(){
    document.title = '新手攻略'
  }
}
</script>
<style scoped>
.novice img{width: 100%; display: block;}
</style>



// WEBPACK FOOTER //
// src/components/novice.vue